import { NetworkType } from '@zorro/clients';
import { parseMaybeEnumValue } from '@zorro/common-utils';

import { planTypeTooltipConfig } from '../../PlanFilter';
import { PlanBadge } from '../PlanBadge';

type Props = {
  networkType?: string | null;
  size?: 'xs' | 'sm' | 'md';
};

export const NetworkTypeBadge = ({
  networkType: networkTypeProp,
  size = 'sm',
}: Props) => {
  const networkType = parseMaybeEnumValue(NetworkType, networkTypeProp);
  if (!networkType) {
    return null;
  }

  return (
    <PlanBadge
      tooltipLabel={planTypeTooltipConfig[networkType]}
      label={networkType}
      size={size}
    />
  );
};
